import { z } from 'zod'

export const RelationshipBadgeEnum = {
  EMPLOYEE: 'EMPLOYEE',
  SPOUSE: 'SPOUSE',
  DOMESTIC_PARTNER: 'DOMESTIC_PARTNER',
  CHILD: 'CHILD',
  ADULT_CHILD: 'ADULT_CHILD',
  CHILD_OF_DOMESTIC_PARTNER: 'CHILD_OF_DOMESTIC_PARTNER',
} as const
export const RelationshipBadgeSchema = z.nativeEnum(RelationshipBadgeEnum)
export type RelationshipBadge = z.infer<typeof RelationshipBadgeSchema>

export type RelationshipIconKey =
  | 'employee'
  | 'spouse'
  | 'domesticPartner'
  | 'child'
  | 'childOfDomesticPartner'

export const RELATIONSHIP_ICON_COLORS: Record<RelationshipIconKey, string> = {
  employee: '#14b8a6',
  spouse: '#7c3aed',
  domesticPartner: '#C9A25F',
  child: '#db2777',
  childOfDomesticPartner: '#8A9A5B',
}

export type RelationshipBadgeStyle = {
  background: string
  borderColor: string
  textColor: string
  dotColor: string
}

export const RELATIONSHIP_BADGE_STYLES: Record<
  RelationshipIconKey,
  RelationshipBadgeStyle
> = {
  employee: {
    background: '#f0fdf4',
    borderColor: '#bbf7d0',
    textColor: '#166534',
    dotColor: '#16a34a',
  },
  spouse: {
    background: '#f5f3ff',
    borderColor: '#ddd6fe',
    textColor: '#5b21b6',
    dotColor: '#7c3aed',
  },
  domesticPartner: {
    background: '#FBF6EC',
    borderColor: '#EAD8B3',
    textColor: '#7A5A1E',
    dotColor: '#C9A25F',
  },
  child: {
    background: '#fdf2f8',
    borderColor: '#fbcfe8',
    textColor: '#9d174d',
    dotColor: '#db2777',
  },
  childOfDomesticPartner: {
    background: '#F5F7EF',
    borderColor: '#D6DCC2',
    textColor: '#4D5A2C',
    dotColor: '#8A9A5B',
  },
}

export type RelationshipConfig = {
  color: string
  label: string
  iconKey: RelationshipIconKey
}

export const RELATIONSHIP_CONFIG: Record<
  RelationshipBadge,
  RelationshipConfig
> = {
  [RelationshipBadgeEnum.EMPLOYEE]: {
    color: RELATIONSHIP_ICON_COLORS.employee,
    label: 'Employee',
    iconKey: 'employee',
  },
  [RelationshipBadgeEnum.SPOUSE]: {
    color: RELATIONSHIP_ICON_COLORS.spouse,
    label: 'Spouse',
    iconKey: 'spouse',
  },
  [RelationshipBadgeEnum.DOMESTIC_PARTNER]: {
    color: RELATIONSHIP_ICON_COLORS.domesticPartner,
    label: 'Domestic Partner',
    iconKey: 'domesticPartner',
  },
  [RelationshipBadgeEnum.CHILD]: {
    color: RELATIONSHIP_ICON_COLORS.child,
    label: 'Child',
    iconKey: 'child',
  },
  [RelationshipBadgeEnum.ADULT_CHILD]: {
    color: RELATIONSHIP_ICON_COLORS.child,
    label: 'Adult Child',
    iconKey: 'child',
  },
  [RelationshipBadgeEnum.CHILD_OF_DOMESTIC_PARTNER]: {
    color: RELATIONSHIP_ICON_COLORS.childOfDomesticPartner,
    label: 'Child of Domestic Partner',
    iconKey: 'childOfDomesticPartner',
  },
}
